export default {
  name: 'Preview',
  path: '/preview',
  meta: {
    title: '预览'
  }
};
